/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutTrackingListEntryPayer } from './CarveOutTrackingListEntryPayer';
import {
    CarveOutTrackingListEntryPayerFromJSON,
    CarveOutTrackingListEntryPayerFromJSONTyped,
    CarveOutTrackingListEntryPayerToJSON,
    CarveOutTrackingListEntryPayerToJSONTyped,
} from './CarveOutTrackingListEntryPayer';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
    ContractSummaryToJSONTyped,
} from './ContractSummary';
import type { PalSubmissionListEntryTimExecutionReportResult } from './PalSubmissionListEntryTimExecutionReportResult';
import {
    PalSubmissionListEntryTimExecutionReportResultFromJSON,
    PalSubmissionListEntryTimExecutionReportResultFromJSONTyped,
    PalSubmissionListEntryTimExecutionReportResultToJSON,
    PalSubmissionListEntryTimExecutionReportResultToJSONTyped,
} from './PalSubmissionListEntryTimExecutionReportResult';

/**
 * Subset of TimExecution for list view
 * @export
 * @interface PalSubmissionListEntryTimExecution
 */
export interface PalSubmissionListEntryTimExecution {
    /**
     * 
     */
    payor?: CarveOutTrackingListEntryPayer;
    /**
     * 
     */
    insurance_type?: string;
    /**
     * 
     */
    reimbursement_type?: string;
    /**
     * 
     */
    report_result?: PalSubmissionListEntryTimExecutionReportResult;
    /**
     * 
     */
    contract?: ContractSummary;
}

/**
 * Check if a given object implements the PalSubmissionListEntryTimExecution interface.
 */
export function instanceOfPalSubmissionListEntryTimExecution(value: object): value is PalSubmissionListEntryTimExecution {
    return true;
}

export function PalSubmissionListEntryTimExecutionFromJSON(json: any): PalSubmissionListEntryTimExecution {
    return PalSubmissionListEntryTimExecutionFromJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryTimExecution {
    if (json == null) {
        return json;
    }
    return {
        
        'payor': json['payor'] == null ? undefined : CarveOutTrackingListEntryPayerFromJSON(json['payor']),
        'insurance_type': json['insurance_type'] == null ? undefined : json['insurance_type'],
        'reimbursement_type': json['reimbursement_type'] == null ? undefined : json['reimbursement_type'],
        'report_result': json['report_result'] == null ? undefined : PalSubmissionListEntryTimExecutionReportResultFromJSON(json['report_result']),
        'contract': json['contract'] == null ? undefined : ContractSummaryFromJSON(json['contract']),
    };
}

export function PalSubmissionListEntryTimExecutionToJSON(json: any): PalSubmissionListEntryTimExecution {
    return PalSubmissionListEntryTimExecutionToJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionToJSONTyped(value?: PalSubmissionListEntryTimExecution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payor': CarveOutTrackingListEntryPayerToJSON(value['payor']),
        'insurance_type': value['insurance_type'],
        'reimbursement_type': value['reimbursement_type'],
        'report_result': PalSubmissionListEntryTimExecutionReportResultToJSON(value['report_result']),
        'contract': ContractSummaryToJSON(value['contract']),
    };
}

